import React, { useState } from 'react';
import SignUp from '../components/SignUp';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

function SignupPage() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ScrollToTop />
      <Sidebar isOpen={isOpen} toggle={toggle} isHeader={true} />
      <Navbar toggle={toggle} isHeader={true} />
      <SignUp />
      <Footer />
    </>
  );
}

export default SignupPage;
